import React, { useState, useEffect, useCallback } from "react"
import useFetch from "use-http"
import { css } from "styled-components"
import { Calendar, dateFnsLocalizer } from "react-big-calendar"
import format from "date-fns/format"
import parse from "date-fns/parse"
import startOfWeek from "date-fns/startOfWeek"
import getDay from "date-fns/getDay"
import "react-big-calendar/lib/css/react-big-calendar.css"
import { hu } from "date-fns/locale"

import Spinner from "./Spinner"

import { useUser } from "../hooks/useUser"

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales: { hu },
})

const TimeTable = () => {
  const { token } = useUser()
  const [events, setEvents] = useState([])
  const [start, setStart] = useState()
  const [init, setInit] = useState(false)

  const { post, response, loading, error } = useFetch(
    process.env.GATSBY_BACKEND_URL
  )

  const loadInitial = useCallback(async () => {
    const initial = await post("/", { token })
    if (response.ok) {
      setEvents(initial)
    }
  }, [token, post, response])

  useEffect(() => {
    if (!init) {
      loadInitial()
      setInit(true)
    }
  }, [init, loadInitial])

  const getData = useCallback(async () => {
    const data = await post("/", {
      token,
      start,
    })

    if (response.ok) {
      setEvents(data)
    }
  }, [start, post, response, token])

  useEffect(() => {
    if (init) {
      getData()
    }
  }, [start, init, getData])

  const changeRange = week => {
    setStart(week[0].getTime())
  }
  return (
    <>
      {loading && (
        <div
          css={css`
            transform: translate(-50%, -50%);
            position: fixed;
            left: 50%;
            top: 50%;
            z-index: 100;
          `}
        >
          <Spinner />
        </div>
      )}
      {error && (
        <div
          css={css`
            color: red;
            font-size: 14px;
            text-align: center;
          `}
        >
          {response.data?.message || error.message}
        </div>
      )}
      <Calendar
        localizer={localizer}
        events={events}
        defaultView={"work_week"}
        views={["day", "work_week"]}
        culture={"hu"}
        onRangeChange={changeRange}
        min={new Date(0, 0, 0, 8, 0, 0)}
        max={new Date(0, 0, 0, 20, 0, 0)}
        timeslots={4}
        step={15}
        messages={{
          work_week: "Hét",
          day: "Nap",
          today: "Ma",
          next: ">>",
          previous: "<<",
        }}
        css={css`
          .rbc-time-view {
            border: 0;
          }
          .rbc-current-time-indicator {
            background: #00d9ed;
            height: 3px;
            z-index: 0;
          }
          .rbc-events-container {
            margin: 0;
          }
          .rbc-event-content {
            margin-top: 3px;
          }
          .rbc-event-label {
            text-overflow: ellipsis;
            width: 100%;
          }
          .rbc-toolbar-label {
            font-size: 14px;
          }
          @media (max-width: 400px) {
            .rbc-toolbar > :last-child {
              display: none;
            }
          }
        `}
        eventPropGetter={event => ({
          style: {
            backgroundColor: event.color || "#00d9eddd",
            width: "100%",
          },
        })}
        startAccessor={event => new Date(event.start)}
        endAccessor={event => new Date(event.end)}
        titleAccessor={event => event.title + "\n[" + event.location + "]"}
        dayLayoutAlgorithm="no-overlap"
      />
    </>
  )
}

export default TimeTable
